export const COPY_PAYMENT_LINK_MESSAGES = {
  success: 'Link de pagamento copiado',
  error: 'Não foi possível copiar o link',
  clipboardUnavailable: 'Clipboard API indisponível',
  fallbackFailed: 'execCommand copy failed',
};
